module.exports = __webpack_public_path__ + "img/rose.9b351c8e.png";